module.exports = __webpack_public_path__ + "static/media/ti.070eef1e.svg";